export enum Routes {
  /** Svaki modulski ruter se montira pod ovom rutom, u vlastitom `<Routes>` bloku. */
  ModuleRouter = "*",

  // Cjenik
  PricingPageRouter = "/pricing",
  /** Jedna verzija cjenika; do nje se dolazi iz pretrage. */
  PricingDetailPageRouter = "/pricing/detail/:versionId",
  PricingSchemesPageRouter = "/pricing-schemes",
  PricingDeviationsPageRouter = "/pricing-deviations",

  // Nadzorna ploča je početni ekran administracije, pa stoji na korijenu — nije jedna od
  // postavki platforme i nema vlastitu podrutu.
  DashboardPageRouter = "/",

  // Platforma
  ApplicationSettingsPageRouter = "/settings",

  // Tenanti
  TenantSearchPageRouter = "/tenant/search",
  TenantDetailPageRouter = "/tenant/detail/:tenantId",
  TenantSubscriptionPageRouter = "/tenant/detail/:tenantId/subscription",
  TenantUsersPageRouter = "/tenant/detail/:tenantId/users",
  TenantInvoicesPageRouter = "/tenant/detail/:tenantId/invoices",
  TenantActivitiesPageRouter = "/tenant/detail/:tenantId/activities",

  // Prijevodi
  TranslationSearchPageRouter = "/translation/search",
  TranslationCreatePageRouter = "/translation/new",
  TranslationEditPageRouter = "/translation/:translationId?",
  TranslationDetailPageRouter = "/translation/detail/:translationId",
  TranslationDeletePageRouter = "/translation/delete/:translationId",

  // Pozadinski poslovi
  CronJobSearchPageRouter = "/cronjob/search",
  CronJobDetailPageRouter = "/cronjob/detail/:cronJobId",
  /** Log jednog izvršavanja; do njega se dolazi s detalja posla. */
  CronJobExecutionPageRouter = "/cronjob/detail/:cronJobId/execution/:executionId",
}
